export default {
  english: {
    now: 'Now',
    hour: '1 hour ago',
    hours: '{{ hours }} hours ago',
    minute: '1 minute ago',
    minutes: '{{ minutes }} minutes ago',
  },
  french: {
    now: 'Maintenant',
    hour: 'Il y a 1 heure',
    hours: 'Il y a {{ hours }} heures',
    minute: 'Il y a 1 minute',
    minutes: 'Il y a {{ minutes }} minutes',
  },
  arabic: {
    now: 'حاليا',
    hour: 'منذ 1 ساعة',
    hours: 'منذ ساعات {{ hours }}',
    minute: 'منذ 1 دقيقة',
    minutes: 'دقائق مضت {{ minutes }}',
  },
  hebrew: {
    now: 'עכשיו',
    hour: 'לפני שעה',
    hours: 'לפני {{ hours }} שעות',
    minute: 'לפני דקה',
    minutes: 'לפני {{ minutes }} דקות',
  },
  persian: {
    now: 'در حال حاضر',
    hour: '1 ساعت پیش',
    hours: '{{ hours }} ساعت قبل',
    minute: '1 دقیقه پیش',
    minutes: '{{ minutes }} دقیقه قبل',
  },
}
